// import firebase from "firebase/app";
// import "firebase/storage";
// import "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import {addUserReading} from "../firebase/user";
import {firestore,storage} from "../firebase/config";
import Swal from 'sweetalert2';

import { confirmAlert } from "react-confirm-alert";
// Firebase configuration
// const firebaseConfig = {
//   apiKey: 'AIzaSyCPhqcw6V8-wTSCkfDe-K2XGE2mGboUGY4',
//   authDomain: 'sharprpm-7e0c1.firebaseapp.com',
//   projectId: 'sharprpm-7e0c1',
//   storageBucket: 'sharprpm-7e0c1.appspot.com',
//   messagingSenderId: '748428012046',
//   appId: '1:748428012046:web:34306907146c8efdd1ea5f',
//   measurementId: 'G-X6MFFFESZ1'
// };

// Initialize Firebase
// if (!firebase.apps.length) {
//   firebase.initializeApp(firebaseConfig);
// }

// const storage = firebase.storage();
// const db = firebase.firestore();


export const onCaptureImageButtonClick = (uid,deviceType,isStandard,devicePW) => {

  //alert(`uid - ${uid}` )
  //window.confirm(`1. Please make sure you are seated. \n2. Take a picture of the device screen in a room with good lighting. \n3. Confirm the reading before pressing "OK".`)

  CaptureImageComponent(uid);

}



function CaptureImageComponent(userId) {

  // const [output, setOutput] = useState(null);
  // const [imageURL, setImageURL] = useState(null);
  // const userId =  "m5lsoC4hpLhEOx8DRo1zYrMNR613"; // Testing UUID

  let output = {};
  let imageURL = '' ;
  //alert(`userId = ${userId}`);

  const handleCapture = async (userId) => {
    //alert("handleCapture");

    try {
      const imageFile = await captureImage(); // Function to capture image
      const fileName = `${userId}/${uuidv4()}`;
      const storageRef = storage.ref(`images/${fileName}`);
      //alert(`fileName: ${fileName}`)
      // Upload the file
      const snapshot = await storageRef.put(imageFile);
      const downloadURL = await snapshot.ref.getDownloadURL();

      // Call OCR Function
      const response = await fetch(
        "https://us-central1-sharprpm.cloudfunctions.net/sharprpm_ocr",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: downloadURL }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        imageURL = downloadURL;
        output = result;
        handleConfirm(userId,imageURL);
      } else {
        throw new Error("Failed to process image");
      }
    } catch (error) {
      console.error("Error capturing or processing image:", error);
    }
  };

  const handleConfirm = async (userId,imageURL) => {
    //alert("handleConfirm");
    const dateNow = new Date( Date.now() );

    const labelsArray = [
      "Systolic",
      "Diastolic",
      "Heart Rate",
      //"Mean Arterial",
      "Date Time",
    ];

    const index = 0;

    const divID = "blueToothReadingsDivbloodPressureMonitor";
    document.getElementById(divID).innerHTML = "ᛒluetooth"
     localStorage.setItem('completed', 1)

    // const dtn = {
    //   time: readingDateTime.toLocaleTimeString("en-US", {
    //     hour: "2-digit",
    //     minute: "2-digit",
    //     hour12: false,
    //   }),
    //   note: `Bluetooth Welch Allyn BP100 ᛒ (MABP:${element[3]})`,
    //   date: readingDateTime
    //     .toLocaleDateString()
    //     .replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2"),  
    // }
    
    try {
      await firestore.collection("posts").add({
        userId,
        timestamp: dateNow, // firebase.firestore.FieldValue.serverTimestamp(),
        image: imageURL,
        response: output,
      });
      //alert("Post confirmed successfully");

      const element  = [
        output.sys, 
        output.dia, 
        output.pulse,
        //0,
        dateNow.toLocaleString()
      ]

      createTable(labelsArray, element, `table${index}`, imageURL, saveReading(userId,output,dateNow));

    } catch (error) {
      console.error("Error confirming post:", error);
    }
  };

  handleCapture(userId);

  // return (
  //   <div className="CaptureImageComponent">
      
  //       <button onClick={handleCapture}>Capture Image</button>
  //       {output && (
  //         <div>
  //           <h2>Output:</h2>
  //           <pre>{JSON.stringify(output, null, 2)}</pre>
  //           <button onClick={handleConfirm}>Confirm Post</button>
  //         </div>
  //       )}
  //   </div>
  // );
}

 const saveReading = (uid,reading,dateTime) => {

  const time = dateTime.toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                });

  const date = dateTime.toLocaleDateString()
                .replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2")

  let selection = "rejected";
  let validationMsg="";
  let validationMsg2="";

  if (reading.sys < 90 || reading.sys > 180) {
    validationMsg = "<br>- SYS <90-180>"
  }
  if (reading.dia < 60 || reading.dia > 120) {
    validationMsg += "<br>- DIA <60-120>"
  }
  if (reading.pulse < 40 || reading.pulse > 280) {
    validationMsg += "<br>- Pulse <40-200>"
  }
  if ( reading.dia  > reading.sys ) {
    validationMsg += "<br>- SYS higher than DIA"
  }
  if ( validationMsg ) {
    validationMsg = `<br><br>WARNING <normal-range>:${validationMsg}<br>`
    validationMsg2 =  " and call your doctor."
  }
  if ( Swal.fire({
    title: 'Confirm Reading',
    html: `SYS: ${reading.sys} <br>
    DIA: ${reading.dia} <br>
    Pulse: ${reading.pulse} <br>
    <span style="color: red; font-weight: bold;display: block;">${validationMsg}</span> <br><br>
    If wrong "Cancel", or If correct "OK"<br> 
    <span style="color: red; font-weight: bold;">${validationMsg2}</span>`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      // User clicked "OK"
      selection = "saved";
      console.log('Reading confirmed');
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // User clicked "Cancel"

      addUserReading({
        uid: uid,
        add: {
          devices: {
            bloodPressureMonitor: {
              time: time,
              note: `Picture Captured`,
              status: 'Rejected',
              date: date,
              reading: {
                Upper: reading.sys,
                Lower: reading.dia,
                Pulse: reading.pulse,
                //"MABP" : element[3]
              },
              device: {
                manufacturer: "Device",
                model: "Camera",
              },
            },
          },
        },
      });


      selection = "rejected";
      console.log('Reading canceled');
    }
  })) {

    addUserReading({
      uid: uid,
      add: {
        devices: {
          bloodPressureMonitor: {
            time: time,
            note: `Picture Captured`,
            status: 'Accepted',
            date: date,
            reading: {
              Upper: reading.sys,
              Lower: reading.dia,
              Pulse: reading.pulse,
              //"MABP" : element[3]
            },
            device: {
              manufacturer: "Device",
              model: "Camera",
            },
          },
        },
      },
    });

    //new Audio('/audio/ReadingAccepted.mp3').play();
    
  } else {
     alert("Reading canceled. Please try again.");
     
  }
  return selection
}

async function captureImage() {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.capture = "environment";

    input.addEventListener("change", (event) => {
      const file = event.target.files[0];
      if (file) {
        resolve(file);
      } else {
        reject(new Error("No image selected"));
      }
    });

    input.click();
  });
}

const createTable = (labelArray, colDataArray, tableClassName, imageURL, disposition) => {
  const divID = "blueToothReadingsDivbloodPressureMonitor";
  if (document.getElementById(divID).innerHTML === "ᛒluetooth") {
    document.getElementById(divID).innerHTML = "";
    localStorage.setItem('completed', 100)
  }

  let table = document.createElement("table"),
    thead = document.createElement("thead"),
    tbody = document.createElement("tbody"),
    th = {},
    tr = {},
    td = {};

  th = document.createElement("th");
  th.innerHTML = "Camera";
  thead.appendChild(th);

  th = document.createElement("th");
  th.innerHTML = `Reading ${disposition}`;
  thead.appendChild(th);

  table.setAttribute("class", tableClassName);
  table.appendChild(thead);
  table.appendChild(tbody);

  //document.body.appendChild(table);
  document.getElementById(divID).appendChild(table);

  for (let i = 0; i < colDataArray.length; i++) {
    tr = document.createElement("tr");

    //for label
    td = document.createElement("td");
    td.innerHTML = labelArray[i];
    td.style.color = "blue";
    tr.appendChild(td);

    //for data
    td = document.createElement("td");
    td.style.color = "black";
    td.innerHTML = colDataArray[i];
    tr.appendChild(td);
    table.appendChild(tr);
  }

  tr = document.createElement("tr");
  td = document.createElement("td");
  td.colSpan = 2; 

  const img = document.createElement("img");
  img.src = imageURL; 
  // Set the width and height of the image (optional)
  img.width = "200"; 
  img.height = "150"; 
  // Append the image to the table data cell
  td.appendChild(img); 
  tr.appendChild(td);

  tbody.appendChild(tr);

};
//export default CaptureImageComponent;

